<div></div>
@if (isChat) {
  <lib-chat-widget
    (addMessage)="addMessage($event)"
    (closeMe)="closeMe.emit()"
    (hideMe)="hideMe.emit()"
    [chatAvatar]="chatAvatar$ | async"
    [chatTitle]="supportHeader$ | async"
    [conversationId]="$safeNavigationMigration((supportStatus$ | async)?.conversationId)"
    [supportThreadId]="$safeNavigationMigration((supportStatus$ | async)?.supportThreadId)"
    [unreadCount]="$safeNavigationMigration((supportStatus$ | async)?.unreadCount)"
    [onlineStatus]="$safeNavigationMigration((supportStatus$ | async)?.onlineStatus)"
  ></lib-chat-widget>
}
@if (isFaq) {
  <lib-faq-container (closeMe)="closeMe.emit()"></lib-faq-container>
}
